import Vue from "vue";
import VueRouter from "vue-router";

import utils from "@/utils";

Vue.use(VueRouter);

// General routes
// import General from '@/pages/General';
import Landing from "@/pages/Landing";
import LandingIndex from "@/pages/Landing/landing";
import Itineraries from "@/pages/Landing/itineraries";

// Auth
import Auth from "@/pages/Auth";
import Login from "@/pages/Auth/Login";
import SignUp from "@/pages/Auth/SignUp";
import ForgotPassword from "@/pages/Auth/passwordReset/ForgotPassword";
import PasswordReset from "@/pages/Auth/passwordReset/PasswordReset";

// Home
import Home from "@/pages/Home";
import Cart from "@/pages/Home/cart";
import Checkout from "@/pages/Home/checkout";
import Products from "@/pages/Home/Products";
import ProductDetails from "@/pages/Home/ProductDetails";

// Profile
import Profile from "@/pages/Home/profile";
import ProfileDetails from "@/pages/Home/profile/ProfileDetails";
import Orders from "@/pages/Home/profile/Orders";
import OrderDetails from "@/pages/Home/profile/OrderDetails";

// eslint-disable-next-line no-unused-vars
const parseProps = r => ({ id: parseInt(r.params.id) }); // converts the param to an integer

// TODO Add param for the from address
//  so that after a successful login the user
// is rerouted back to where they came from
const routes = [
  {
    path: "",
    component: Landing,
    children: [
      {
        path: "",
        name: "Landing",
        component: LandingIndex
      },
      {
        path: "itineraries",
        name: "Itineraries",
        component: Itineraries
      }
    ]
  },
  {
    path: "/auth",
    name: "Auth",
    component: Auth,
    children: [
      {
        path: "login",
        name: "Login",
        component: Login,
        props: { username: "" }
      },
      {
        path: "signup",
        name: "Signup",
        component: SignUp
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword
      },
      {
        path: "new-password/:passwordResetToken",
        name: "PasswordReset",
        component: PasswordReset,
        props: r => ({
          passwordResetToken: r.params.passwordResetToken
        })
      }

      // TODO: Add a 'NotFound' page
    ]
  },
  {
    path: "/home",
    component: Home,
    children: [
      {
        path: "",
        name: "Home",
        component: Products
      },
      {
        path: "product/:id",
        name: "ProductDetails",
        component: ProductDetails
      },
      {
        path: "cart",
        name: "Cart",
        component: Cart
      },
      {
        path: "checkout",
        name: "Checkout",
        component: Checkout,
        beforeEnter(to, from, next) {
          console.log(from, to);
          if (utils.authTokenExists()) next();
          else next(utils.buildLoginRedirect(to));
        }
      },
      {
        path: "profile",
        component: Profile,
        beforeEnter(to, from, next) {
          if (utils.authTokenExists()) next();
          else next(utils.buildLoginRedirect(to));
        },
        children: [
          {
            path: "",
            name: "Profile",
            component: ProfileDetails
          },
          {
            path: "orders",
            name: "Orders",
            component: Orders
          },
          {
            path: "orders/:id",
            name: "OrderDetails",
            component: OrderDetails
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: "kt-frontend",
  routes
});

// router guards
// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
  next();
});

export default router;
